import { render, staticRenderFns } from "./ModalEditLocationLanguages.vue?vue&type=template&id=7bc4b13b"
import script from "./ModalEditLocationLanguages.vue?vue&type=script&lang=js"
export * from "./ModalEditLocationLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports